import React from "react";
import styled from "styled-components";
import autobind from "autobind-decorator";
import onClickOutside from "react-onclickoutside";

// --------------------------------------------------

const Menu = styled.div`
	background: white;
	width: 20em;
	font-size: 16px;
	padding: 0.5em 0;
	position: fixed;
	z-index: 1000000000;
`;

const Option = styled.div`
	border: 0;
	height: 3em;
	padding: 0 1.5em 0 3.5em;
	line-height: 3;
	position: relative;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;

	&:hover {
		background: rgba(0,0,0,0.1);
	}
`;

const Label = styled.span``;

// --------------------------------------------------

class ContextMenu extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			top: true,
			left: true,
		};
	}

	@autobind
	handleClickOutside() {
		this.props.close();
	}

	componentDidMount() {
		// const el = this.menuEl;
		// const bounds = el.getBoundingClientRect();
		// if(bounds.bottom > window.innerHeight) {
		// 	this.setState({ top: false, });
		// }
		// if(bounds.right > window.innerWidth) {
		// 	this.setState({ left: false, });
		// }
	}

	@autobind
	menuRef(cmp) {
		this.menuEl = cmp || this.menuEl;
	}

	render() {
		const props = this.props;
		const style = {};
		style.top = this.state.top ? props.y : null;
		style.bottom = this.state.top ? null : window.innerHeight - props.y;
		style.left = this.state.left ? props.x : null;
		style.right = this.state.left ? null : window.innerWidth - props.x;

		return (
			<div>
			<Menu
				style = { style }
				innerRef = { this.menuRef }
			>
				{
				props.options.map((option, i) => (
					<Option
						className = "ooption"
						key = { i }
						onClick = { (e) => {
							e.stopPropagation();
							option.fn(e);
							props.close();
						}}
					>
						<Label>
							{ option.label }
						</Label>
					</Option>
				))
			}
			</Menu>
			</div>
		);
	}
}

const Test = styled.div`
	position: fixed;
	width: 200px;
	height: 200px;
	background-color: blue;
	top: 50%;
	left: 50%;
	margin-top: -100px;
	margin-left: -100px;
`;

export default ContextMenu;
// export default onClickOutside(ContextMenu);
// export default onClickOutside(Test);
